module.exports = __webpack_public_path__ + "static/media/meditation-image-page.71f7c8b3.png";